import styled from 'styled-components';

export const WidgetWrapper = styled.div`
`;
